// extracted by mini-css-extract-plugin
export default {"container":"Month-module__container--qgQq3","row":"Month-module__row--jOq5L","title":"Month-module__title--b0lmV","compressedHeader":"Month-module__compressedHeader--NBkkR"};